<div class="row">
    <div [ngClass]="(payDetail | json) != '{}' ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #payDetailGrid
                    [data]="gridData"
                    [sort]="gridState.sort"
                    [sortable]="false"
                    [pageable]="false"
                    [filterable]="false"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" width="105">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="canEdit(dataItem)&&readonly!=true">
                        <button (click)="edit(dataItem)" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1"><i class="fas fa-pencil-alt"></i></button>
                        <button (click)="delete(dataItem)" class="btn btn-sml btn-danger" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="legNumber" title="Load #"></kendo-grid-column>
            <kendo-grid-column field="carrierCode" title="Carrier">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.carrierID > 0">
                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                            {{dataItem.carrierCode}}
                        </a>
                        <br />
                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                            {{dataItem.carrierName}}
                        </a>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="payDetailTypeAbbrev" title="Type">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div>{{dataItem.payDetailTypeAbbrev}}</div>
                    <div>{{dataItem.payDetailTypeDescription}}</div>
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="authCode" title="Auth Code"></kendo-grid-column>-->
            <kendo-grid-column field="description" title="Description"></kendo-grid-column>
            <kendo-grid-column title="Amount">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div>{{dataItem.description}} ({{dataItem.abbrev}})</div>
                    <div>Qty: {{dataItem.quantity}} Rate: {{dataItem.rate != null ? (dataItem.rate | currency) : ''}}</div>
                    <div>Total: {{dataItem.amount != null ? (dataItem.amount | currency) : ''}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="notes" title="Notes"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="carrierID>0&&readonly!=true"><i class="fas fa-plus"></i></button>
    </div>
    <div class="col" *ngIf="(payDetail | json) != '{}'">
        <pay-detail-form [payDetail]="payDetail" [pageType]="pageType" (onRefresh)="getPayDetails()"></pay-detail-form>
    </div>
</div>
